import { render, staticRenderFns } from "./DeviceDataTab.vue?vue&type=template&id=1a03e10c&scoped=true"
import script from "./DeviceDataTab.vue?vue&type=script&lang=ts"
export * from "./DeviceDataTab.vue?vue&type=script&lang=ts"
import style0 from "./DeviceDataTab.vue?vue&type=style&index=0&id=1a03e10c&prod&scoped=true&lang=scss"
import style1 from "./DeviceDataTab.vue?vue&type=style&index=1&id=1a03e10c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a03e10c",
  null
  
)

export default component.exports